import { ProjectDto } from '@/core';

export const validateEpicsTab = (projectData: ProjectDto) => {
  return !!projectData.epics.length;
};
